window.addEventListener('DOMContentLoaded', () => {
  // eslint-disable-next-line no-new
  new Swiper('.static-container', {
    slidesPerView: 1.3,
    centeredSlides: true,
    loop: true,
    spaceBetween: 16,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
    lazy: {
      loadPrevNext: true,
    },
    breakpoints: {
      750: {
        spaceBetween: 32,
        slidesPerView: 2.5,
      },
    },
  });

  function requestDiscount(element, code) {
    fetch(`/discount/${code}`)
      .then((response) => {
        if (response.ok) {
          element.disabled = false;
        }
      })
      .catch(() => {});
  }

  function copyToCouponClipboard(element) {
    if (element.disabled !== true) {
      element.disabled = true;
      const copyTarget = element.previousElementSibling;
      copyTarget.select();
      document.execCommand('Copy');
      alert('クーポンコード [' + copyTarget.value + '] をコピーしました。');
      requestDiscount(element, copyTarget.value);
    }
  }

  const couponCopyButton = document.getElementsByClassName('brand-block-coupon-button');
  Array.from(couponCopyButton).forEach((element) => {
    element.addEventListener('click', (e) => {
      copyToCouponClipboard(e.currentTarget);
    });
  });
});
